var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { creatorLightTheme } from '@spotify-internal/encore-web/core';
import { useActiveSubmenuContext } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { useSubmenuItem } from '../../ActiveSubmenu/useSubmenuItem';
import { isFlyoutSubMenu } from '../FlyoutMenu/SubMenu';
import { flyoutTransitionMixin } from '../FlyoutMenu/config';
import { useScrollYPosition } from '../../../utils/useScrollYPosition';
var invertedDark = creatorLightTheme.invertedDark;
var defaultColors = {
    text: invertedDark.text.base,
    background: invertedDark.background.base
};
var StyledThemeWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), flyoutTransitionMixin('background-color', 'color'));
export var NavThemeProvider = function (_a) {
    var children = _a.children, colors = _a.colors;
    var activeSubmenu = useActiveSubmenuContext().activeSubmenu;
    var activeItem = useSubmenuItem(activeSubmenu);
    var isFlyout = activeItem && isFlyoutSubMenu(activeItem);
    var scrollPos = useScrollYPosition();
    var isScrolling = scrollPos !== 0;
    var forceInvertedDark = isFlyout || isScrolling;
    return (React.createElement(ThemeProvider, { theme: forceInvertedDark
            ? {
                background: invertedDark.background.base,
                text: invertedDark.text.base,
                isFlyout: isFlyout,
                isScrolling: isScrolling,
                forceInvertedDark: forceInvertedDark
            }
            : __assign(__assign(__assign({}, defaultColors), colors), { isFlyout: isFlyout, isScrolling: isScrolling, forceInvertedDark: forceInvertedDark }) },
        React.createElement(StyledThemeWrapper, null, children)));
};
var templateObject_1;
